<div class="stopwatch">
	<button class="stopwatch-close-button" type="button"
		(click)="close.emit()"><img src="../../../../../assets/img/arrow.svg" alt=""></button>
	<div class="stopwatch-content">
		<div class="wrapper-play-title">
			<button class="stopwatch-play" (click)="startTimer()">
				<img *ngIf="!running" src="../../../../../assets/img/play.svg" alt="">
				<img *ngIf="running" src="../../../../../assets/img/pause.svg" alt="">
			</button>
			<div class="stopwatch-informations">
				<div class="stopwatch-label">
					{{ title }}
				</div>
				<div class="stopwatch-timer" [ngClass]="{'stopwatch-exceeded': expired}">
					<div class="stopwatch-counter">{{counter | date: 'H:mm:ss': 'UTC'}}</div>
					<div class="stopwatch-duration"> / {{duration | date: 'H:mm:ss': 'UTC'}}</div>
				</div>
			</div>
		</div>
		<button class="stopwatch-reset" (click)="clearTimer()"><img src="../../../../../assets/img/restart.svg" alt=""></button>
	</div>
</div>
